<template>
  <div class="flex-wrap">
    <template v-if="type === 'LEGACY_ENGINE'">
      <a class="url" >
        <img src="@/assets/images/preview_icon.svg" alt="icon" class="eye-icon">
        <span class="text" @click="previewClasseContent">
          {{ $t("PREVIEW") }}
        </span>
      </a>
    </template>
    <a v-else class="url-view" @click="downloadOrViewCollection" :class="{'top-line': entryStatus !== entryApprovalStatuses.PUBLISHED}">
      <img v-if="type=='FILE' || type == 'AUDIO'" src="@/assets/images/download_icon_black.svg" alt="download icon">
      <img v-if="type== 'EXTERNAL' || type== 'VIDEO_YOUTUBE' || type== 'VIDEO_UPLOAD'" src="@/assets/images/open_new_tab_black.svg" alt="download icon">
      <span class="text">
        {{ getButtonName() }}
      </span>
    </a>
    <button class="common-button" v-if="entryStatus === entryApprovalStatuses.PUBLISHED" :class="{
      'btn-add-to-unit': !unitAdded,
      'view-button': unitAdded
    }" @click="addOrShowToMyUnits">
      <span  v-if="!this.unitAdded" class="text">
        {{ $t('ADD_CLASSE_CONTENT') }}
      </span>
      <span v-else class="text">
        {{ $t('WATCH_CONTENT') }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getClasseUnitUrl } from '@/utilityFunctions'
import { entryApprovalStatuses } from '@/constants'

export default {
  name: 'entry-usage-bar',

  data () {
    return {
      entryApprovalStatuses
    }
  },

  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      url: state => state.collections.selectedEntry.object.url,
      id: state => state.collections.selectedEntry.data.id,
      selectedEntry: state => state.collections.selectedEntry
    }),
    unitAdded () {
      return JSON.parse(sessionStorage.getItem('existUnits'))?.includes(this.id)
    },
    entryStatus () {
      return this.selectedEntry.data.published_status
    }
  },
  methods: {
    getButtonName () {
      switch (this.type) {
        case 'LEGACY_ENGINE':
          if (!this.unitAdded) {
            return this.$t('ADD_CLASSE_CONTENT')
          } else {
            return this.$t('WATCH_CONTENT')
          }
        case 'FILE':
          return this.$t('DOWNLOAD_FILE')
        case 'EXTERNAL':
        case 'VIDEO_YOUTUBE':
        case 'VIDEO_UPLOAD':
          return this.$t('LINK')
        case 'AUDIO':
          return this.$t('DOWNLOAD_AUDIO')
        default:
          return this.$t('NOT_SUPPORTED')
      }
    },
    downloadOrViewCollection () {
      switch (this.type) {
        case 'FILE': case 'AUDIO':
          this.$store.dispatch('downloadContent', this.id)
          break
        case 'EXTERNAL': case 'VIDEO_YOUTUBE': case 'VIDEO_UPLOAD':
          this.openContentInNewWindow()
          break
        default:
          alert('this file is not supported')
      }
    },
    addOrShowToMyUnits () {
      this.$store.dispatch('setLoader', true)
      if (this.type === 'LEGACY_ENGINE') {
        this.$store.dispatch('addToMyCollection', this.id).then((response) => {
          this.$store.dispatch('setLoader', false)
          if (this.unitAdded) {
            window.open(getClasseUnitUrl(response.data.unit_id), '_blank')
          } else {
            const existUnits = JSON.parse(sessionStorage.getItem('existUnits')) || []
            existUnits.push(this.id)
            sessionStorage.setItem('existUnits', JSON.stringify(existUnits))
            this.$router.push({
              name: 'successAddToMyArea',
              params: {
                unitId: response.data.unit_id
              }
            })
          }
        }
        ).catch((error) => {
          this.$store.dispatch('setLoader', false)
          console.log(error)
        })
      } else {
        this.$store.dispatch('addExternalContentToMyCollection', { contentId: this.id }).then((response) => {
          this.$store.dispatch('setLoader', false)
          if (this.unitAdded) {
            window.open(getClasseUnitUrl(response.data.unit_id), '_blank')
          } else {
            const existUnits = JSON.parse(sessionStorage.getItem('existUnits')) || []
            existUnits.push(this.id)
            sessionStorage.setItem('existUnits', JSON.stringify(existUnits))
            this.$router.push({
              name: 'successAddToMyArea',
              params: {
                unitId: response.data.unit_id
              }
            })
          }
        }
        ).catch((error) => {
          this.$store.dispatch('setLoader', false)
          console.log(error)
        })
      }
    },
    openContentInNewWindow () {
      window.open(this.url)
    },
    previewClasseContent () {
      // do something
      this.$store.dispatch('previewClasseContent', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.url-view{
  &.top-line{border-top: 1px solid #E0E0E0; width: 100%; padding-top: 25px;}
  &:hover{
    .text{text-decoration: underline;}
  }
}
</style>
